<template>
	<div class="list">
		<div class="group_list_top">
			<div class="inputBox">
				<div class="flex-c-1">
					<div class="filter-box">
						<span class="title">群主：</span>
						<el-select v-model="search.group_leader" placeholder="请选择" @change="searchBtn">
							<el-option :key="0" label="全部群主" :value="0"></el-option>
							<el-option v-for="value in member.list" :key="value.userid" :label="value.name"
								:value="value.userid"></el-option>
						</el-select>
					</div>
					<div class="filter-box mt17">
						<span class="title">排序条件：</span>
						<el-select v-model="search.sort_condition" placeholder="请选择" @change="searchBtn">
							<el-option :key="1" label="群内总人数排名" :value="1"></el-option>
							<el-option :key="2" label="入群人数排名" :value="2"></el-option>
							<el-option :key="3" label="退群人数排名" :value="3"></el-option>
							<el-option :key="4" label="创群时间" :value="4"></el-option>
						</el-select>
					</div>
				</div>
				<div class="flex-c-1">
					<div class="filter-box">
						<span class="title">群名称：</span>
						<el-input style="width: 195px;" placeholder="请输入要搜索的群名称" @keyup.enter.native="searchBtn"
							v-model="search.group_name">
							<i slot="suffix" class="el-input__icon el-icon-search"></i>
						</el-input>
					</div>
					<div class="filter-box mt17">
						<span class="title">排序方式：</span>
						<el-select v-model="search.sort_mode" placeholder="请选择" @change="searchBtn">
							<el-option :key="0" label="降序" :value="0"></el-option>
							<el-option :key="1" label="升序" :value="1"></el-option>
						</el-select>
					</div>
				</div>
				<div class="flex-c-1">
					<div class="filter-box">
						<span class="title">群标签：</span>
						<el-select v-model="search.group_label" placeholder="请选择标签" @click.native="open_select_label">
						</el-select>
					</div>
					<div class="filter-box mt17">
						<span class="title">群聊状态：</span>
						<el-select v-model="search.group_state" placeholder="请选择" @change="searchBtn">
							<el-option :key="0" label="未解散" :value="0"></el-option>
							<el-option :key="1" label="已解散" :value="1"></el-option>
						</el-select>
					</div>
				</div>

				<div class="flex-c-1">
					<div class="filter-box">
						<span class="title">选择日期：</span>
						<el-date-picker v-model="select_date" type="date" placeholder="选择日期">
						</el-date-picker>
					</div>

				</div>

			</div>
			<div class="resetBox">
				<el-button class="reset" @click="reset">重置</el-button>
			</div>
		</div>

		<div class="group_list_content">
			<div class="content_top">
				<div class="left">
					<span class="group_count">共{{data.total || 0}}个群，{{customer_num || 0}}个客户</span>
					<el-divider direction="vertical"></el-divider>
					<span class="update" @click="uploadData">
						<svg t="1620717911804" class="icon" viewBox="0 0 1024 1024" version="1.1"
							xmlns="http://www.w3.org/2000/svg" p-id="15397" width="16" height="16">
							<path
								d="M394.2 767.5c-0.5-0.2-1-0.3-1.5-0.6-141.8-66.1-203.4-235.3-137.3-377.1 36.8-78.9 105.5-132.9 183.7-153.9L404 169.4c-91.9 29.3-171.8 95-215.7 189.1C105 537.3 182.6 750.6 361.4 834l1.5 0.6-46 98.6 230.8-49.8-110.3-208.7-43.2 92.8zM663.8 185.5l44-94.3L477 141l110.2 208.8 45.3-97.2c141.8 66.1 203.3 235.2 137.2 377-37.2 79.8-107.1 134.2-186.4 154.7l35.1 66.5c93-28.9 174.1-95 218.4-190 83.4-178.6 5.8-391.9-173-475.3z"
								p-id="15398" fill="#707070"></path>
						</svg>
						更新数据
					</span>
				</div>
				<div class="right">
					<el-button class="top_btn" @click="open_group_label">批量打群标签</el-button>
					<el-button class="top_btn" @click="exportExcel">导出 Excel</el-button>
				</div>

			</div>
			<div class="content_table">
				<el-table id="table" class="group_list_table" :data="data.list"
					:header-cell-style="{background:'rgb(249,249,249)'}" ref="multipleTable"
					:row-style="{height: '60px'}" style="width: 99%;margin: 0 auto">
					<el-table-column type="selection" align="center" fixed width="50">
					</el-table-column>
					<el-table-column prop="chat_name" align="left" label="群名称" fixed>
						<template v-slot="scope">
							<div class="group_name" v-if="curfield_power.chat_name != 3">
								<img class="icon" src="~assets/img/group.svg" alt="">
								<span class="name">{{scope.row.chat_name}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="member_name" align="center" label="群主" width="150">
						<template v-slot="scope">
							<span style="border: 1px solid;padding: 5px 10px;border-radius: 2px">
								<span>
									<i>
										<svg t="1620206845175" class="icon" viewBox="0 0 1024 1024" version="1.1"
											xmlns="http://www.w3.org/2000/svg" p-id="2069" width="16" height="16">
											<path
												d="M623.1 604.2c-4.7 0-37.3-18.2-18.6-77.4 51.2-54.6 93.1-141.1 93.1-223 0-132-88.5-200.2-186.3-200.2-102.4 0-186.3 68.3-186.3 200.2 0 86.5 41.9 172.9 93.1 227.5 18.6 50.1-18.6 72.8-27.9 72.8C287.8 645.1 162 713.3 162 781.6V809c0 91 181.6 113.8 349.2 113.8S860.6 900 860.6 809v-27.3c0-72.8-125.7-141.1-237.5-177.5z m0 0"
												fill="#1296db" p-id="2070"></path>
										</svg>
									</i>
								</span>
								{{scope.row.member_name}}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="tag" align="center" label="群标签" width="220">
						<template v-slot="scope">
							<span v-for="value in scope.row.tag" class="label_span"
								v-if="curfield_power.tag_id != 3">{{value.name}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="total_people" align="center" label="群人数" width="100">
						<template v-slot="scope">
							<span v-if="curfield_power.total_people != 3">
								{{scope.row.total_people}}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="today_total" align="center" label="当日群人数" width="100">

					</el-table-column>
					<el-table-column prop="today_join" align="center" label="当日入群" width="100">
						<template v-slot="scope">
							<span v-if="curfield_power.join_people != 3">
								{{scope.row.today_join}}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="today_quit" align="center" label="当日退群" width="100">
						<template v-slot="scope">
							<span v-if="curfield_power.quit_people != 3">
								{{scope.row.today_quit}}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="create_time" align="center" label="创建时间" width="100">
						<template v-slot="scope">
							<span v-if="curfield_power.create_time != 3">
								{{scope.row.create_time}}
							</span>
						</template>
					</el-table-column>
					<!--          <el-table-column-->
					<!--              prop="chat_id"-->
					<!--              align="center"-->
					<!--              label="群ID"-->
					<!--              width="300">-->
					<!--          </el-table-column>-->
					<el-table-column label="操作" width="200">
						<template v-slot="scope">
							<!--              <span class="tab_btn">设置群日历</span>-->
							<span class="tab_btn" @click="open_set_task">设置群SOP</span>
							<el-dropdown trigger="click" placement="bottom">
								<span class="el-dropdown-link tab_btn" style="margin-left: 10px">
									打标签<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<!--                  <el-dropdown-item @click.native="open_group_in_label">给群内客户打标签</el-dropdown-item>-->
									<el-dropdown-item @click.native="open_group_label1(scope.row.id, scope.row.tag)">
										给群聊打标签</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<span class="tab_btn"
								@click="toDetails(scope.row.id, scope.row.chat_id, scope.row.userid)">详情</span>
						</template>
					</el-table-column>
				</el-table>

				<div class="btn_right">
					<div style="float: right">
						<el-pagination background layout="total,sizes, prev, pager, next" prev-text="上一页"
							next-text="下一页" :page-sizes="[20, 50, 100, 200, 500]" :page-size="data.pagesize"
							:pager-count='5' @size-change="type_modify_page" @current-change="type_switch_page"
							:total="data.total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>

		<Dialog :show.sync.sync="group_in_label_show" :name_width="group_in_label_dialog" class="group_in_label_dialog">
			<span slot="body">
				<div class="box">
					<p class="alert-panel">
						<span>将给群内12个客户批量打标签，请选择标签</span>
					</p>
					<el-input placeholder="请输入内容" v-model="group_in_label.label">
						<i slot="suffix" class="el-input__icon el-icon-search"></i>
					</el-input>
					<div class="labelBox">
						<p class="title">客户等级：</p>
						<div class="label_list">
							<el-input style="width: 100px;margin-right: 5px;" class="input-new-tag"
								v-show="inputVisible" v-model="inputValue" placeholder="输入后回车" ref="saveTagInput"
								size="small" @keyup.enter.native="handleInputConfirm()" @blur="closeAddLable()">
							</el-input>
							<el-button v-show="!inputVisible" class="button-new-tag btn" style="margin-right: 5px;"
								size="small" @click="showInput()">+ 添加</el-button>

							<span class="label_span" :class="{'click': thisOneLabel.indexOf(value) !== -1}"
								@click="clickLabel(value, index)" v-for="(value, index) in label_list">{{value}}</span>

						</div>
					</div>
				</div>

			</span>
			<div slot="footer">
				<el-button type="primary" @click="save_group_in_label">创 建</el-button>
				<el-button @click="close_group_in_label">取 消</el-button>
			</div>
		</Dialog>

		<Dialog :show.sync.sync="group_label_show" :name_width="group_label_dialog" class="group_in_label_dialog">
			<span slot="body">

				<div class="labelBox1" v-for="value in label.list">
					<p class="title">{{value.name}}：</p>
					<div class="label_list">
						<span class="label_span" :class="{'click': thisOneLabel.indexOf(tag.id) !== -1}"
							@click="clickLabel(tag.id, index)" v-for="(tag, index) in value.tag">{{tag.name}}</span>
					</div>
				</div>

			</span>
			<div slot="footer">
				<el-button type="primary" @click="save_group_label">保 存</el-button>
				<el-button @click="close_group_label">取 消</el-button>
			</div>
		</Dialog>

		<Dialog :show.sync.sync="select_label_show" :name_width="select_label_dialog" class="group_in_label_dialog">
			<span slot="body">

				<div class="labelBox1" v-for="value in label.list">
					<p class="title">{{value.name}}：</p>
					<div class="label_list">
						<span class="label_span" :class="{'click': thisLabel.indexOf(tag.id) !== -1}"
							@click="clickLabel1(tag, index)" v-for="(tag, index) in value.tag">{{tag.name}}</span>
					</div>
				</div>

			</span>
			<div slot="footer">
				<el-button type="primary" @click="save_select_label">确 定</el-button>
				<el-button @click="close_select_label">取 消</el-button>
			</div>
		</Dialog>

		<Dialog :show.sync.sync="set_task_show" :name_width="set_task_dialog" class="group_in_label_dialog">
			<span slot="body">
				<span>选择推送规则：</span>
				<el-select v-model="task.value" placeholder="请选择" @change="getCustomerBaseTask(task.value)">
					<el-option v-for="item in task.list" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<div class="container">
					<div class="top">
						<span class="title">共{{task_info.content.length}}条推送计划</span>
					</div>

					<div class="content">
						<el-timeline>
							<el-timeline-item
								:timestamp="value.type === 0 ?'加入规则当天，'+value.hour+'小时'+value.minute+'分后提醒发送（'+value.name+'）' : '加入规则'+value.day+'天后，'+value.time1+'提醒发送（'+value.name+'）'"
								placement="top" v-for="value in task_info.content">
								<div class="box">
									<span class="count">共{{value.content_list.length}}条消息</span>
									<div class="inner">
										<span class="intro-title">推送消息数：共{{value.content_list.length}}条</span>
										<div class="text_content" v-for="item in value.content_list">{{item.content}}
										</div>
									</div>
								</div>
							</el-timeline-item>
						</el-timeline>
					</div>
				</div>
			</span>
			<div slot="footer">
				<el-button type="primary" @click="save_set_task">确 定</el-button>
				<el-button @click="close_set_task">取 消</el-button>
			</div>
		</Dialog>

	</div>
</template>

<script>
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'

	import Dialog from "components/content/dialog/Dialog";

	import {
		getCustomerBaseList,
		getCustomerBaseTagList,
		setCustomerBaseTag,
		getCustomerBaseTaskList,
		getCustomerBaseTask
	} from 'network/hk_qiwei'
	import {
		getMemberDetailedList
	} from 'network/hk_member'
	import {
		retujudpower,
		retupower,
		alertMess,
		retfieldPower,
		fn_fielddisabled,
	} from '@src/network/kh_public'
	export default {
		name: "List",
		components: {
			Dialog
		},
		data() {
			return {
				select_date: '',

				curfield_power: '',
				curkey: 'customer_base',

				is_powerAdd: false,
				is_powerEdit: false,
				is_powerDel: false,
				is_powerImp: false,
				is_powerExp: false,
				is_powerRec: false,
				group_in_label_show: false,
				group_in_label_dialog: {
					name: '批量打标签',
					width: '500px'
				},
				group_label_show: false,
				group_label_dialog: {
					name: '给群聊打标签',
					width: '500px'
				},
				select_label_show: false,
				select_label_dialog: {
					name: '选择标签',
					width: '500px'
				},
				set_task_show: false,
				set_task_dialog: {
					name: '设置群任务',
					width: '500px'
				},


				search: {
					group_leader: 0,
					sort_condition: 1,
					group_name: '',
					sort_mode: 0,
					group_label: '',
					group_state: 0,
				},
				show_label_name: [],

				data: {
					pagesize: 20,
					page: 1,
					total: 0,
					list: []
				},
				// 共几个客户
				customer_num: 0,

				label: {
					pagesize: 20,
					page: 1,
					list: []
				},
				member: {
					pagesize: 20,
					page: 1,
					list: []
				},


				// 勾选的群聊
				group_list: [],
				group_id_list: [],

				// 单个打标签
				group_id: null,

				group_in_label: {
					label: ''
				},
				label_list: ['标签1', '标签2', '标签3'],
				thisOneLabel: [],
				thisLabel: [],
				inputVisible: false,
				inputValue: '',

				// 设置群任务
				task: {
					pagesize: 20,
					page: 1,
					list: [],
					value: ''
				},
				task_info: {
					content: []
				}
			}
		},
		created() {
			this.curfield_power = retfieldPower(this.curkey)
			this.judgePower()
			this.getCustomerBaseList(this.data.pagesize, this.data.page, '', '', this.search.group_name, this.search
				.group_state, this.search.sort_condition, this.search.sort_mode)
			this.getMemberDetailedList(this.member.pagesize, this.member.page)
		},
		methods: {
			judgePower() {
				this.is_powerAdd = retupower('163')
				this.is_powerEdit = retupower('164')
				this.is_powerDel = retupower('165')
				this.is_powerImp = retupower('166')
				this.is_powerExp = retupower('167')
				this.is_powerRec = retupower('168')
			},
			toDetails(id, chat_id, userid) {
				this.$router.push({
					path: '/qiwei/group_list/details',
					query: {
						url: '/qiwei/group_list/list',
						id: id,
						chat_id: chat_id
					}
				})
			},

			open_group_in_label() {
				this.group_in_label_show = true
			},
			save_group_in_label() {
				this.group_in_label_show = false
			},
			close_group_in_label() {
				this.group_in_label_show = false
			},

			open_set_task() {
				if (retujudpower(this.is_powerEdit)) {
					this.getCustomerBaseTaskList(this.task.pagesize, this.task.page)
					this.set_task_show = true
				}

			},
			save_set_task() {
				this.set_task_show = false
			},
			close_set_task() {
				this.set_task_show = false
			},

			open_group_label() {
				if (retujudpower(this.is_powerEdit)) {
					this.thisOneLabel = []
					this.group_list = this.$refs.multipleTable.selection
					this.group_id_list = this.group_list.map(function(item, idnex) {
						return item.id
					})
					if (this.group_id_list.length === 0) {
						this.$message({
							message: '请选择要设置的群聊',
							type: 'warning',
							offset: 100
						});
					} else {
						this.getCustomerBaseTagList(this.label.pagesize, this.label.page)
						this.group_label_show = true
					}
				}

			},
			open_group_label1(id, tag) {
				if (retujudpower(this.is_powerEdit)) {
					this.group_id = id
					this.thisOneLabel = tag.map(function(item, idnex) {
						return item.id
					})
					this.getCustomerBaseTagList(this.label.pagesize, this.label.page)
					this.group_label_show = true
				}

			},
			save_group_label() {
				this.setCustomerBaseTag(this.group_id_list.join(), this.thisOneLabel.join() + ',')
			},
			close_group_label() {
				this.group_label_show = false
			},

			// 选择标签弹窗
			open_select_label() {
				this.getCustomerBaseTagList(this.label.pagesize, this.label.page)
				this.select_label_show = true
			},
			save_select_label() {
				this.search.group_label = this.show_label_name.join()
				this.getCustomerBaseList(this.data.pagesize, this.data.page, '', this.thisLabel.join(), this.search
					.group_name, this.search.group_state, this.search.sort_condition, this.search.sort_mode)
				this.select_label_show = false
			},
			close_select_label() {
				this.select_label_show = false
			},


			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.label_list.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			closeAddLable() {
				this.inputVisible = false;
				this.inputValue = '';
			},
			clickLabel(value, index) {
				if (this.thisOneLabel.indexOf(value) === -1) {
					this.thisOneLabel.push(value)
				} else {
					this.thisOneLabel.splice(this.thisOneLabel.indexOf(value), 1)
				}
			},
			clickLabel1(value, index) {
				if (this.thisLabel.indexOf(value.id) === -1) {
					this.thisLabel.push(value.id)
					this.show_label_name.push(value.name)
				} else {
					this.thisLabel.splice(this.thisLabel.indexOf(value.id), 1)
					this.show_label_name.splice(this.show_label_name.indexOf(value.name), 1)
				}
			},

			exportExcel() {
				/* generate workbook object from table */
				let wb = XLSX.utils.table_to_book(document.querySelector('#table'));
				/* get binary string as output */
				let wbout = XLSX.write(wb, {
					bookType: 'xlsx',
					bookSST: true,
					type: 'array'
				});
				try {
					FileSaver.saveAs(new Blob([wbout], {
						type: 'application/octet-stream'
					}), '客户群列表.xlsx');
				} catch (e) {
					if (typeof console !== 'undefined')
						console.log(e, wbout)
				}
				return wbout
			},
			// 重置
			reset() {
				this.search = {
					group_leader: 0,
					sort_condition: 1,
					group_name: '',
					sort_mode: 0,
					group_label: [],
					group_state: 0
				}
				this.getCustomerBaseList(this.data.pagesize, this.data.page, '', '', this.search.group_name, this.search
					.group_state, this.search.sort_condition, this.search.sort_mode)
			},

			// 搜索
			searchBtn() {
				this.getCustomerBaseList(this.data.pagesize, this.data.page, this.search.group_leader, this.thisLabel
					.join(), this.search.group_name, this.search.group_state, this.search.sort_condition, this.search
					.sort_mode)
			},
			// 更新数据
			uploadData() {
				this.getCustomerBaseList1(this.data.pagesize, this.data.page, this.search.group_leader, this.thisLabel
					.join(), this.search.group_name, this.search.group_state, this.search.sort_condition, this.search
					.sort_mode)
			},

			type_modify_page(val) {
				this.data.pagesize = val
				this.getCustomerBaseList1(this.data.pagesize, this.data.page, this.search.group_leader, this.thisLabel
					.join(), this.search.group_name, this.search.group_state, this.search.sort_condition, this.search
					.sort_mode)
			},
			type_switch_page(val) {
				this.data.page = val
				this.getCustomerBaseList1(this.data.pagesize, this.data.page, this.search.group_leader, this.thisLabel
					.join(), this.search.group_name, this.search.group_state, this.search.sort_condition, this.search
					.sort_mode)
			},

			// 客户群列表
			getCustomerBaseList(pagesize, page, userid, tag_id, chat_name, is_lock, sort_condition, sort_type) {
				getCustomerBaseList(pagesize, page, userid, tag_id, chat_name, is_lock, sort_condition, sort_type).then(
					res => {
						if (res.code === 10000) {
							this.data.list = res.result.data
							this.data.total = res.result.total
							this.customer_num = res.result.customer_num
						}
					})
			},
			// 更新数据
			getCustomerBaseList1(pagesize, page, userid, tag_id, chat_name, is_lock, sort_condition, sort_type) {
				getCustomerBaseList(pagesize, page, userid, tag_id, chat_name, is_lock, sort_condition, sort_type).then(
					res => {
						if (res.code === 10000) {
							this.data.list = res.result.data
							this.data.total = res.result.total
							this.customer_num = res.result.customer_num
							this.$message({
								message: '更新成功',
								type: 'success',
								offset: 100
							});
						}
					})
			},
			// 客户群标签
			getCustomerBaseTagList(pagesize, page) {
				getCustomerBaseTagList(pagesize, page).then(res => {
					if (res.code === 10000) {
						this.label.list = res.result.data
					}
				})
			},
			// 打客户群标签
			setCustomerBaseTag(id, tag_id) {
				setCustomerBaseTag(id, tag_id).then(res => {
					if (res.code === 10000) {
						this.$message({
							message: '打群标签成功',
							type: 'success',
							offset: 100
						});
						this.getCustomerBaseList(this.data.pagesize, this.data.page, this.search.group_leader, '',
							this.search.group_name, this.search.group_state, this.search.sort_condition, this
							.search.sort_mode)
						this.group_label_show = false
					}
				})
			},

			// 成员列表
			getMemberDetailedList(pagesize, page) {
				getMemberDetailedList(pagesize, page).then(res => {
					if (res.code === 10000) {
						this.member.list = res.result.data
					}
				})
			},
			// 任务列表
			getCustomerBaseTaskList(pagesize, page) {
				getCustomerBaseTaskList(pagesize, page).then(res => {
					if (res.code === 10000) {
						this.task.list = res.result.data
					}
				})
			},
			// 任务详情
			getCustomerBaseTask(id) {
				getCustomerBaseTask(id).then(res => {
					if (res.code === 10000) {
						this.task_info = res.result
						this.task_info.content = JSON.parse(this.task_info.content)
					}
				})
			},
		}
	}
</script>

<style scoped>
	.list .group_list_top {
		background: #fff;
		padding: 24px;
		display: flex;
		justify-content: space-between;
	}

	.group_list_top .inputBox {
		display: flex;
	}

	.inputBox .flex-c-1 {
		margin-right: 20px;
	}

	.inputBox .flex-c-1 .filter-box {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.inputBox .flex-c-1 .filter-box .title {
		color: rgba(0, 0, 0, .65);
		font-size: 14px;
		white-space: nowrap;
	}

	.group_list_top .resetBox {
		display: flex;
		flex-direction: column-reverse;
	}

	.group_list_content {
		margin-top: 10px;
		background: #FFFFFF;
	}

	.group_list_content .content_top {
		padding: 16px 28px;
		display: flex;
		justify-content: space-between;
	}

	.group_list_content .content_top .left {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.group_list_content .content_top .group_count {
		font-size: 14px;
		font-weight: 600;
		color: rgba(18, 18, 22, .85);
	}

	.group_list_content .content_top .update {
		display: flex;
		align-items: center;
		font-size: 13px;
		color: rgba(0, 0, 0, .45);
		cursor: pointer;
	}


	.group_list_table .group_name {
		display: flex;
		align-items: center;
	}

	.group_list_table .group_name .icon {
		width: 36px;
		height: 36px;
		border-radius: 3px;
	}

	.group_list_table .group_name .icon img {
		width: 100%;
		height: 100%;
	}

	.group_list_table .group_name .name {
		margin-left: 10px;
		word-break: normal;
		display: block;
		word-warp: break-word;
		overflow: hidden;
	}

	.group_in_label_dialog .label_span {
		padding: 7px 10px;
		border: 1px solid rgb(227, 226, 229);
		border-radius: 4px;
		cursor: pointer;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.group_in_label_dialog .click {
		background: #f0f9eb;
		border-color: #e1f3d8;
		color: var(--themeColors);
	}

	.group_in_label_dialog .label_list {
		display: flex;
		flex-wrap: wrap;
	}


	.top_btn {
		height: 32px;
		padding: 0 15px;
		background: var(--themeColors);
		color: #fff;
		border: none;
	}

	.top_btn:hover {
		background: var(--themeColorsHover);
	}

	.btn {
		height: 32px;
		padding: 0 15px;
	}

	.mt17 {
		margin-top: 17px;
	}

	/deep/ .el-divider--vertical {
		width: 2px;
		margin: 0 15px;
	}

	/deep/ .el-table .cell {
		overflow: inherit;
	}


	.group_in_label_dialog .box {
		/*height: 510px;*/
		/*max-height: 510px;*/
		/*min-height: 300px;*/
		overflow: auto;
	}

	.group_in_label_dialog .alert-panel {
		padding: 8px 13px 8px 21px;
		font-size: 13px;
		line-height: 18px;
		background: #effaff;
		color: rgba(0, 0, 0, .85);
		position: relative;
		margin-bottom: 20px;
	}

	.group_in_label_dialog .alert-panel:before {
		display: block;
		content: "";
		width: 3px;
		height: 12px;
		background: #b8b8b8;
		position: absolute;
		left: 12px;
		top: 11px;
	}

	.group_in_label_dialog .labelBox {
		margin-top: 15px;
	}

	.group_in_label_dialog .labelBox .title {
		font-size: 13px;
		line-height: 18px;
		color: #999;
		margin-bottom: 16px;
		white-space: nowrap;
		word-break: break-all;
	}

	.group_in_label_dialog .labelBox1 .title {
		font-size: 13px;
		line-height: 18px;
		color: #999;
		margin-bottom: 16px;
		white-space: nowrap;
		word-break: break-all;
	}

	.label_span {
		padding: 5px 10px;
		border: 1px solid #eee;
		border-radius: 4px;
		margin: 0 3px;
	}

	.btn_right {
		height: 50px;
		margin-top: 15px;
		margin-right: 10px;
	}

	.box .count {
		font-size: 13px;
		font-weight: 400;
		color: rgba(0, 0, 0, .45);
		line-height: 24px;
	}

	.box .inner {
		background: #fbfbfb;
		border: 1px solid #f2f2f2;
		position: relative;
		padding: 10px 20px 8px 16px;
		box-sizing: border-box;
	}

	.box .inner .intro-title {
		padding-left: 12px;
		font-size: 13px;
		font-weight: 400;
		color: rgba(0, 0, 0, .45);
		line-height: 18px;
		position: relative;
	}

	.box .inner .intro-title:before {
		content: "";
		position: absolute;
		left: 0;
		top: 2px;
		width: 3px;
		height: 13px;
		background: var(--themeColors);
	}

	.box .inner .groups {
		display: -webkit-box;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		flex-wrap: wrap;
		margin-top: 8px;
		list-style: none;
	}

	.box .inner .groups>li {
		display: -webkit-box;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		width: 242px;
		height: 64px;
		padding: 14px;
		box-sizing: border-box;
		background: #fff;
		border-radius: 2px;
		border: 1px solid #f2f2f2;
		margin-right: 16px;
		margin-bottom: 5px;
		list-style: none;
	}

	.box .inner .groups>li>img {
		width: 36px;
		border-radius: 3px;
		margin-right: 10px;
	}

	.box .inner .groups>li .group-info {
		-webkit-box-flex: 1;
		flex: 1;
		overflow: hidden;
	}

	.box .inner .groups>li .group-info .name-info {
		max-width: 100%;
		display: -webkit-box;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: start;
		justify-content: flex-start;
	}

	.box .inner .groups>li .group-info .name-info .group-name {
		font-size: 13px;
		font-weight: 600;
		color: #333;
		line-height: 18px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		word-break: break-all;
	}

	.box .inner .groups>li .group-info .name-info .count {
		font-size: 12px;
		font-weight: 400;
		color: #999;
		line-height: 17px;
	}

	.box .inner .groups>li .group-owner {
		margin-top: 2px;
		display: -webkit-box;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		font-size: 12px;
		font-weight: 400;
		color: #000;
		line-height: 17px;
	}

	.box .inner .groups>li .group-owner {
		-webkit-box-flex: 1;
		flex: 1;
		overflow: hidden;
		color: rgba(0, 0, 0, .65);
		word-break: keep-all;
		white-space: nowrap;
		text-overflow: ellipsis;
	}


	.box .inner .text_content {
		background: #fff;
		box-shadow: 0 0 2px 0 rgb(0 0 0 / 4%);
		border-radius: 2px 16px 16px 24px;
		border: 1px solid #f6f6f6;
		padding: 10px 16px;
		word-break: break-all;
		font-size: 14px;
		font-weight: 400;
		color: rgba(0, 0, 0, .86);
		line-height: 20px;
		margin-top: 12px;
	}
</style>
